export default "__VITE_ASSET__Dyi6vNDW__"